import React from 'react';
import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { formatMoney } from '@lialo/common/lib/formatter/money';
import { TourVisibility } from '@lialo/core/lib/models';

const PREFIX = 'TourPriceTag';

const classes = {
  chip: `${PREFIX}-chip`,
  small: `${PREFIX}-small`,
  medium: `${PREFIX}-medium`,
  large: `${PREFIX}-large`,
};

const StyledChip = styled(Chip)(({ theme }) => ({
  [`&.${classes.chip}`]: {
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[300]}`,
    height: 'initial',
    cursor: 'pointer',
  },

  [`&.${classes.small}`]: {
    fontSize: '0.7rem',
    padding: theme.spacing(0),
  },

  [`&.${classes.medium}`]: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.25),
  },

  [`&.${classes.large}`]: {
    fontSize: '1rem',
    padding: theme.spacing(0.5),
  },
}));

interface IProps {
  price?: string;
  tourVisibility: TourVisibility | undefined;
  purchased: boolean;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export const TourPriceTag = ({ price, purchased, tourVisibility, className, size = 'medium' }: IProps) => {
  const { t } = useTranslation();

  const label = purchased
    ? t('common.price_tag.purchased')
    : price
    ? formatMoney(price)
    : t('common.price_tag.free_of_charge');

  // don't show prices for free private or friends tours
  if (!price && !purchased && tourVisibility !== TourVisibility.PUBLIC) {
    return null;
  }

  return <StyledChip size={'small'} className={classNames(classes.chip, classes[size], className)} label={label} />;
};
